import { render, staticRenderFns } from "./PromotionDappRewardDiscount.vue?vue&type=template&id=1a28904d&scoped=true&"
import script from "./PromotionDappRewardDiscount.vue?vue&type=script&lang=js&"
export * from "./PromotionDappRewardDiscount.vue?vue&type=script&lang=js&"
import style0 from "./PromotionDappRewardDiscount.vue?vue&type=style&index=0&id=1a28904d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a28904d",
  null
  
)

export default component.exports